<template>
    <div>
        <el-card>
            <div slot="header">
                <span class="top_title">出入库明细</span>
            </div>
            <div class="searchItem">
                <div class="search">
                    <span class="searchtips">日期:</span>
                    <el-date-picker
                        v-model="searchDate.dateRan"
                        type="daterange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="width: 230px"
                        :editable="false"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </div>
                <div class="search">
                    <span class="searchtips">业务:</span>
                    <el-select
                        v-model="searchDate.type"
                        placeholder=""
                        clearable
                        @visible-change="$forceUpdate()"
                        style="width:160px"
                    >
                        <el-option
                            v-for="(item, index) in business"
                            :key="index"
                            :value="item.id"
                            :label="item.label"
                            style="
                                height: 40px;
                                padding: 10px;
                                line-height: 20px;
                            "
                        />
                    </el-select>
                </div>
                <div class="search">
                    <span class="searchtips">仓库:</span>
                    <el-select
                        v-model="searchDate.wid"
                        placeholder=""
                        clearable
                        multiple
                        collapse-tags
                        @visible-change="$forceUpdate()"
                        style="width:160px"
                    >
                        <el-option
                            v-for="(item, index) in wList"
                            :key="index"
                            :value="item.id"
                            :label="item.name"
                            style="
                                height: 40px;
                                padding: 10px;
                                line-height: 20px;
                            "
                        />
                    </el-select>
                </div>
               
                <div class="search">
                    <span class="searchtips">商品:</span>
                    <el-input
                        v-model="searchDate.pname"
                        clearable
                        style="width:180px"
                    >
                    </el-input>
                </div>
                <div class="search">
                    <span class="searchtips">客户:</span>
                    <el-input
                        v-model="searchDate.cname"
                        clearable
                        style="width:160px"
                    >
                    </el-input>
                </div>
                <div class="search">
                    <span class="searchtips">颜色:</span>
                    <el-input
                        v-model="searchDate.color"
                        clearable
                        style="width:160px"
                    >
                    </el-input>
                </div>
                <div class="search">
                    <span class="searchtips">尺码:</span>
                    <el-input
                        v-model="searchDate.size"
                        clearable
                        style="width:160px"
                    >
                    </el-input>
                </div>
                <div class="search">
                    <span class="searchtips">备注:</span>
                    <el-input
                        v-model="searchDate.note"
                        clearable
                        style="width:160px"
                    >
                    </el-input>
                </div>
                <div class="search">
                    <el-button type="primary" icon="el-icon-search" @click="searchOrder()">查询</el-button>
                </div>
                <div class="search">
                    <el-dropdown v-if="$common.checkWindowsEnv()" @command="print">
                        <el-button type="primary">
                            <i class="el-icon-printer"></i><span>打印</span>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="1">打印入库</el-dropdown-item>
                            <el-dropdown-item command="2">打印出库</el-dropdown-item>
                            <el-dropdown-item command="3">打印更改</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown @command="changePdf">
                        <el-button type="primary">
                            <i class="el-icon-document"></i><span>导出</span>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="1">导出入库</el-dropdown-item>
                            <el-dropdown-item command="2">导出出库</el-dropdown-item>
                            <el-dropdown-item command="3">导出更改</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div>
                <el-button @click="colsDialog = !colsDialog" style="height:40px">
                    列设置
                </el-button>
            </div>
            
            <el-table
                :data="tableData"
                v-loading="loading"
                style="
                    width: 100%;
                    margin-top: 20px;
                    margin-bottom: 20px;
                "
                border
                show-summary
                :summary-method="getSummaries"
            >
                <el-table-column label="操作" width="120px" align="center">
                    <template slot-scope="props">
                        <el-button type="text" v-if="props.row.editable>0&&$common.hasLimits('recordReportEdit')" @click="openEditDialog(props.row)">编辑</el-button>
                        <el-button type="text" v-if="$common.hasLimits('recordReportDelete')" @click="cancelSend(props.row.id)">取消</el-button>
                    </template>
                </el-table-column>
                <template v-for="(col, index) in cols">
                    <template v-if="col.show">
                        <el-table-column v-if="col.prop=='oremark'" show-overflow-tooltip :key="index" :prop="col.prop" :label="col.label" :width="col.width" :align="col.align">
                            <template slot-scope="scope">
                                <div class="uni_ellipsis">{{ scope.row.oremark }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-else :key="index" :prop="col.prop" :label="col.label" :width="col.width" :align="col.align">
                            <template #header v-if="col.column">
                                {{col.label}}
                                <el-button circle icon="el-icon-top" size="mini" v-if="searchDate.column==col.column&&searchDate.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
                                <el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
                                <el-button circle icon="el-icon-bottom" size="mini" v-if="searchDate.column==col.column&&searchDate.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
                                <el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
                            </template>
                        </el-table-column>
                    </template>
                </template>
            </el-table>
            <el-pagination
                style="text-align: right"
                @size-change="handleSizeChange($event)"
                @current-change="handleCurrentChange($event)"
                :current-page="currentPage"
                :page-sizes="[20, 50, 120, 250]"
                :page-size="cp_pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :pager-count="5"
            >
            </el-pagination>
        </el-card>
        <el-dialog :visible.sync="EditDialog" title="编辑出入库" width="60%">
            <el-form
                ref="invoiceform"
                :inline="true"
                label-width="80px"
            >
                <el-form-item
                    label="业务类型"
                >
                <div style="width: 240px">{{edit.type}}</div>
                </el-form-item>
                <el-form-item
                    label="商品"
                >
                    <el-autocomplete
                        style="width:240px;"
                        v-model="edit.name"
                        :fetch-suggestions="querySearchAsync"
                        :disabled="!allowSetPro"
                        @select="changeAuto">
                    </el-autocomplete>
                </el-form-item>
                <el-form-item
                    label="规格"
                >
                <div style="width: 240px">{{edit.spec}}</div>
                </el-form-item>
                <el-form-item
                    :label="'数量('+$global.pack+')'"
                    v-if="$global.buyType!=2"
                >
                    <el-input
                        v-model="edit.count"
                        maxlength="20"
                        style="width: 240px"
                        @input="$common.checkNumber($event,edit,'count')"
                    />
                </el-form-item>
                <el-form-item
                    :label="'数量('+$global.unit+')'"
                    v-if="$global.buyType!=1"
                >
                    <el-input
                        v-model="edit.num"
                        maxlength="20"
                        style="width: 240px"
                        @input="$common.checkNumber($event,edit,'num')"
                    />
                </el-form-item>
                <el-form-item label="仓库" v-if="edit.wid>0">
                    <el-select v-model="edit.wid">
                        <el-option v-for="item in wList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="价格(元)">
                    <el-input
                        v-model="edit.price"
                        style="width: 240px"
                        @input="$common.checkMoney($event,edit,'price')"
                    />
                </el-form-item>
                <el-form-item label="备注">
                    <el-input
                        v-model="edit.note"
                        maxlength="50"
                        style="width: 240px"
                    />
                </el-form-item>
            </el-form>
            <div style="display:flex;justify-content: center;">
                <el-button type="primary" @click="saveEdit()">确认</el-button>
                <el-button @click="cancelEdit()">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="colsDialog" title="列设置" width="60%">
			<column-edit :cols="cols" />
			<div slot="footer" class="dialog-footer" v-if="$global.userType==0">
                <el-button type="text" @click="cols = initCols();" style="float:left">恢复默认设置</el-button>
				<el-button type="primary" @click="saveCols">保存</el-button>
			</div>
		</el-dialog>
        <ReportOrder ref="roder"></ReportOrder>
        <edit-share ref="share"></edit-share>
    </div>
</template>

<script>
import ReportOrder from '@/components/printshare/reportorder.vue';
import editShare from '@/components/printshare/edit_share';
import columnEdit from '@/components/table-column/Column.vue';
export default {
    components:{
        columnEdit,
        ReportOrder,
        editShare,
    },
    data() {
        return {
            loading:false,
            controlModel:0,
            searchDate: {
                dateRan: "",
                pname:"",
                cname:'',
                wid:[],
                type:'',
                column:'',
                order:'',
                color:'',
                size:'',
                note:'',
            },
            pickerOptions: {shortcuts:this.$common.initPickerOptions()},
            wList:[],
            currentPage: 1,
            cp_pagesize: 20,
            total: 100,
            tableData: [],
            totalData:{},
            searchObj:{},
            business:[
                {
                    id:1,
                    label:'入库'
                },{
                    id:2,
                    label:'出库'
                },{
                    id:3,
                    label:'更改库存'
                },
            ],
            EditDialog:false,
            edit:{
                type:'',
                name:'',
                spec:'',
                count:0,
                num:0,
                pid:'',
                spid:'',
                srid:'',
                punit:1,
                price:0,
                note:'',
                wid:'',
            },
            allowSetPro:false,
            colsDialog:false,
            cols:[],
        };
    },
    created() {
        this.tableData = [];
        this.searchObj = {
            page: this.currentPage,
            limit: this.cp_pagesize,
        };
        this.getCollectionDetails();
        this.getWareHouse();
        if(this.$global.userType==0){
            this.$api.getTableCols({tableName: 'ipad_storeDetail'}).then(res=>{
                if(res.data.code==1){
                    let obj = res.data.data;
                    if(obj.cols){
                        let arr = this.initCols();
                        obj.cols.forEach(e=>{
                            let prop = e.prop;
                            let show = e.show;
                            for(let i in arr){
                                if(arr[i].prop==prop){
                                    let target = arr.splice(i,1);
                                    target[0].show = show;
                                    this.cols.push(target[0]);
                                    break;
                                }
                            }
                        })
                        if(arr.length>0){
                            this.cols.push(...arr);
                        }
                    }else{
                        this.cols = this.initCols();
                    }
                }else{
                    this.cols = this.initCols();
                }
            })
        }else if(this.$global.userType==1){
            this.cols = this.initCols();
        }
    },
    methods: {
        print(val){
            let key = parseInt(val)+10;
			let array = [];
			let cmp = this.$global.cmpId.cmp;
			array.push(cmp);
			this.$nextTick(()=>{
				this.$refs.roder.extraOpen(key,array);
			})
		},
		changePdf(val){
            let key = parseInt(val)+10;
			let array = [1];
			this.$nextTick(()=>{
				this.$refs.share.openList(array,key,this.searchObj);
			})
		},
        saveCols(){
            let obj = {
                tableName:'ipad_storeDetail',
                data:JSON.stringify(this.cols),
            }
            this.$api.setTableCols(obj).then(res=>{
                if(res.data.code==1){
                    this.$notify({
                        title: "列设置",
                        message: "修改成功",
                        type: "success",
                        duration: 2000,
                    });
                }
            })
            this.colsDialog = false;
        },
        initCols(){
            let arr = [{
                prop: 'date',
                label: '日期',
                width: 140,
                show: true,
                align:'left',
                column:'date'
            },{
                prop: 'ename',
                label: '操作人员',
                width: 120,
                show: true,
                align:'left',
            },{
                prop: 'cname',
                label: '指定客户',
                width: 180,
                show: true,
                align:'left',
            },{
                prop: 'wname',
                label: '仓库',
                width: '',
                show: true,
                align:'left',
            },{
                prop: 'pname',
                label: '商品',
                width: 200,
                show: true,
                align:'left',
                column:'p_number',
            },{
                prop: 'spec',
                label: '规格',
                width: 100,
                show: true,
                align:'left',
            },{
                prop: 'unitDesc',
                label: '包装单位',
                width: '',
                show: true,
                align:'left',
            },{
                prop: 'price',
                label: '单价(元)',
                width: '',
                show: true,
                align:'left',
            },{
                prop: 'oper',
                label: '业务类型',
                width: '',
                show: true,
                align:'left',
            },{
                prop: 'indesc',
                label: '商品入库',
                width: 120,
                show: true,
                align:'left',
            },{
                prop: 'inprice',
                label: '入库总价(元)',
                width: 120,
                show: true,
                align:'left',
            },{
                prop: 'outdesc',
                label: '商品出库',
                width: 120,
                show: true,
                align:'left',
            },{
                prop: 'outprice',
                label: '出库总价(元)',
                width: 120,
                show: true,
                align:'left',
            },{
                prop: 'chdesc',
                label: '库存更改',
                width: 120,
                show: true,
                align:'left',
            },{
                prop: 'chprice',
                label: '更改总价(元)',
                width: 120,
                show: true,
                align:'left',
            },{
                prop: 'note',
                label: '备注',
                width: 120,
                show: true,
                align:'left',
            },]
            return arr;
        },
        querySearchAsync(qs,cb){
            let result = [];
            this.$api.productlistProduct({product:qs}).then((res)=>{
                if(res.data.code==1){
                    let data = res.data.data;
                    data.forEach(e=>{
                        e.specs.forEach(s=>{
                            let spec = "";
                            if(s.color){
                                spec = s.color+"/"+s.size;
                            }else{
                                spec = "默认";
                            }
                            let obj = {
                                id:e.id,
                                value:e.name+'-'+spec,
                                spec:spec,
                                spid:s.id,
                            }
                            result.push(obj);
                        })
                    })
                    cb(result);
                }
            })
        },
        changeAuto(e){
            if(e){
                this.edit.name = e.value;
                this.edit.pid = e.id;
                this.edit.spid = e.spid;
                this.edit.spec = e.spec;
            }
        },
        saveEdit(){
            let obj = {
                pid:this.edit.pid,
                spid:this.edit.spid,
                srUnit:this.edit.num+this.edit.count*this.edit.punit,
                srid:this.edit.srid,
                price:this.edit.price,
                note:this.edit.note,
				wid:this.edit.wid,
            }
            this.$api.editScanRecord(obj).then(res=>{
                if(res.data.code==1){
                    this.$notify({
                        title: "出入库详细",
                        message: "修改成功",
                        type: "success",
                        duration: 1000,
                        onClose:()=>{
                            this.tableData = [];
                            this.getCollectionDetails();
                        }
                    });
                }else{
                    this.$common.error(res.data.msg);
                }
                this.EditDialog = false;
            })
        },
        cancelEdit(){
            this.EditDialog = false;
        },
        openEditDialog(item){
            this.allowSetPro = item.editable==2?true:false;
            this.edit.type = item.oper;
            this.edit.name = item.pname;
            this.edit.punit = item.punit;
            this.edit.spec = item.spec;
            this.edit.price = item.price;
            this.edit.note = item.note;
            this.edit.wid = item.wid?item.wid:'';
            if(this.$global.buyType==2){
                this.edit.num = item.srunit;
            }else{
                this.edit.count = Math.floor(item.srunit/item.punit);
                this.edit.num = item.srunit-item.punit*this.edit.count;
            }
            this.edit.pid = item.pid;
            this.edit.spid = item.spid?item.spid:'0';
            this.edit.srid = item.id;
            this.EditDialog = true;
        },
        cancelSend(val){
            this.$confirm("警告", {
                title: "警告",
                message: '是否取消当前库存记录？',
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$api.cancelScanRecord({srid:val}).then(res=>{
                    if(res.data.code==1){
                        this.$notify({
                            title: "出入库详细",
                            message: "取消成功",
                            type: "success",
                            duration: 1000,
                            onClose:()=>{
                                this.tableData = [];
                                if((this.searchObj.page-1)*(this.searchObj.limit)>=(this.total-1)){
                                    this.searchObj.page=1;
                                    this.currentPage=1;
                                }
                                this.getCollectionDetails();
                            }
                        });
                    }else{
                        this.$common.error(res.data.msg);
                    }
                })
            },() => {});
            
        },
        getSummaries(param){
            let sums = [];
            sums[0] = '合计';
            let index = 0;
            if(this.cols.length>0){
                for(let i in this.cols){
                    let target = this.cols[i];
                    if(target.show){
                        index++;
                        if(target.prop=="indesc"){
                            sums[index] = this.$common.changeNumDesc(this.totalData,'inamountsum','inpartssum','inunitsum');
                        }else if(target.prop=="inprice"){
                            sums[index] = this.totalData.insumprice;
                        }else if(target.prop=="outdesc"){
                            sums[index] = this.$common.changeNumDesc(this.totalData,'outamountsum','outpartssum','outunitsum');
                        }else if(target.prop=="outprice"){
                            sums[index] = this.totalData.outsumprice;
                        }else if(target.prop=="chdesc"){
                            sums[index] = this.$common.changeNumDesc(this.totalData,'editamountsum','editpartssum','editunitsum');
                        }else if(target.prop=="chprice"){
                            sums[index] = this.totalData.editsumprice;
                        }else{
                            sums[index] = "";
                        }
                    }
                }
            }
            return sums;
        },
        getWareHouse(){
            this.$api.listWareHouse().then((res)=>{
                if(res.data.code==1){
                    let data =res.data.data;
                    this.wList = data;
                }
            })
        },
        searchOrder(){
            this.searchObj = {
                page: 1,
                limit: this.cp_pagesize,
            };
            this.currentPage = 1;
            if(this.searchDate.dateRan&&this.searchDate.dateRan.length>=2){
                this.searchObj.start = this.searchDate.dateRan[0];
                this.searchObj.end = this.searchDate.dateRan[1];
            }
            if(this.searchDate.pname){
                this.searchObj.pname = this.searchDate.pname;
            }
            if(this.searchDate.cname){
                this.searchObj.cname = this.searchDate.cname;
            }
            if(this.searchDate.wid.length>0){
                this.searchObj.wid = this.searchDate.wid.join(',');
            }
            if(this.searchDate.type){
                this.searchObj.type = this.searchDate.type;
            }
            if(this.searchDate.color){
                this.searchObj.color = this.searchDate.color;
            }
            if(this.searchDate.size){
                this.searchObj.size = this.searchDate.size;
            }
            if(this.searchDate.note){
                this.searchObj.note = this.searchDate.note;
            }
            this.sortTime();
        },
        setSort(column,order){
            if(this.searchDate.column==column&&this.searchDate.order==order){
                this.searchDate.column = '';
                this.searchDate.order = '';
            }else{
                this.searchDate.column = column;
                this.searchDate.order = order;
            }
            this.sortTime();
        },
        sortTime(){
            if(this.searchDate.column){
                this.searchObj.column = this.searchDate.column;
                this.searchObj.order = this.searchDate.order?'asc':'desc';
            }else{
                delete this.searchObj.column;
                delete this.searchObj.order;
            }
            this.getCollectionDetails();
        },
        handleSizeChange(val) {
            this.cp_pagesize = val;
            this.searchOrder();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.searchObj.page = val;
            this.getCollectionDetails();
        },
        getCollectionDetails() {
            this.loading = true;
            this.$api.getCollectionDetails(this.searchObj).then((res) => {
                if (res.data.code == 1) {
                    this.tableData = [];
                    this.total = res.data.count;
                    let data = res.data.data.list;
                    this.totalData = res.data.data.total;
                    this.totalData.outamountsum = -this.totalData.outamountsum;
                    this.totalData.outpartssum = -this.totalData.outpartssum;
                    this.totalData.outsumprice = -this.totalData.outsumprice;
                    this.totalData.outunitsum = -this.totalData.outunitsum;
                    if(data!=null&&data.length>0){
                        data.forEach(e => {
                            e.spec = e.color?e.color+"/"+e.size:"默认";
                            e.unitDesc = e.punit+this.$global.unit+'/'+this.$global.pack;
                            if(e.in){
                                e.indesc=this.$common.changeNumDesc(e,'srAmount','srParts','srunit');
                                e.inprice = e.srunit*e.price;
                            }
                            if(e.oper=='扫码出库'){
                                e.editable = 0;
                            }
                            if(e.out){
                                e.srAmount = -e.srAmount;
                                e.srParts = -e.srParts;
                                e.srunit = -e.srunit;
                                e.outdesc=this.$common.changeNumDesc(e,'srAmount','srParts','srunit');
                                e.outprice = e.srunit*e.price;
                            }else if(e.type==2&&e.srstateunit!=0){
                                e.srStateAmount = -e.srStateAmount;
                                e.srStateParts = -e.srStateParts;
                                e.srstateunit = -e.srstateunit;
                                e.outdesc="直接出库:"+this.$common.changeNumDesc(e,'srStateAmount','srStateParts','srstateunit');
                                e.outprice = e.srstateunit*e.price;
                            }else if(e.edit>0){
                                e.srAmount = Math.abs(e.srAmount);
                                e.srParts = Math.abs(e.srParts);
                                e.srunit = Math.abs(e.srunit);
                                e.chdesc=this.$common.changeNumDesc(e,'srAmount','srParts','srunit');
                                e.chprice = e.srunit*e.price;
                            }
                            this.tableData.push(e);
                        });
                    }
                    this.loading = false;
                }
            });
        },
    },
};
</script>
